import SoftwareList from '~/models/softwareStrategy/Software';
import { Software } from '../models/Software';

export default class SoftwareHelper {
  private static readonly SOFTWARE_STORAGE_KEY = 'software';

  public static getSelectedSoftware(): string | null {
    return localStorage.getItem(this.SOFTWARE_STORAGE_KEY);
  }

  public static setSelectedSoftware(selectedSoftware: object) {
    localStorage.setItem(this.SOFTWARE_STORAGE_KEY, JSON.stringify(selectedSoftware));
  }

  public static removeSelectedSoftware() {
    localStorage.removeItem(this.SOFTWARE_STORAGE_KEY);
  }

  public static getSelectedSoftwareObject(): any {
    return JSON.parse(this.getSelectedSoftware() ?? '{}');
  }

  public static isAutoV10(software: any) {
    return software?.type === SoftwareList.AUTO;
  }

  public static validateSoftware(software: any) {
    return !!software?.id;
  }

  public static selectAvailableSoftware(software: Array<Software>): void {
    const selectedSoftware = SoftwareHelper.getSelectedSoftwareObject();
    if (software.length === 0) {
      SoftwareHelper.removeSelectedSoftware();
    }
    if (software.some(software => software.id === selectedSoftware?.id) === false) {
      SoftwareHelper.setSelectedSoftware(software[0].safeAttributes);
    }
  }
}
